<template>
    <section v-if="exhibitors.length">
        <h2 class="text-center">{{ __('Participating organisations') }}</h2>
        <div class="bg-gray">
            <div class="container p-content py-4">
                <div class="carousel-wrapper position-relative">
                    <div id="exhibitorCarousel" class="owl-carousel exhibitor-slider">
                        <a v-for="exhibitor in exhibitors" class="expo-rounded slide" :href="exhibitor.detail_uri">
                            <div class="logo pb-2 px-2">
                                <img class="img-fluid" :src="exhibitor.logo">
                            </div>
                            <div class="info pt-2">
                                <span>{{ exhibitor.name }}</span>
                                <span class="text-muted" v-if="exhibitor.stand">{{ exhibitor.stand }}</span>
                            </div>
                        </a>
                    </div>
                    <div class="nav nav-prev">
                        <div @click="navigate('prev')" class="clickable">
                            <i class="fa fa-chevron-left"></i>
                        </div>
                    </div>
                    <div class="nav nav-next">
                        <div @click="navigate('next')" class="clickable">
                            <i class="fa fa-chevron-right"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                locale : null,
                loading: true,
                exhibitors : [],
                owl: null,
            }
        },
        methods: {
            reset() {
                this.loadExhibitors();
            },
            loadExhibitors() {
                this.loading = true;
                axios.get('/'+ this.locale +'/exhibitors/all', { params : { with_logo: true, random: true }})
                     .then(response => {
                        this.exhibitors = response.data;
                        this.loading = false;

                        Vue.nextTick(() => {
                            this.initCarousel();
                        })
                     });
            },
            initCarousel() {
                this.owl = jQuery('#exhibitorCarousel').owlCarousel({
                    dots: false,
                    responsive: {0:{items: 1},600:{items: 3}, 992:{items: 5}},
                    margin: 15,
                    slideBy: 5,
                    autoplay: true ,
                    autoplayTimeout: 6000,
                });
            },
            navigate(direction)
            {
                this.owl.trigger(direction +'.owl.carousel')
                this.owl.trigger('stop.owl.autoplay');
                this.owl.trigger('play.owl.autoplay');
            }
        },
        mounted() {
            this.locale = window._locale;

            this.loadExhibitors();
        },
    }
</script>
